// The code in this file will load on every page of your site

$w.onReady(function () {
	$w('#leaveButton').setAttribute('label', "Exit Now");
	$w('#leaveButton').setAttribute('url_open', 'https://www.google.com');
	$w('#leaveButton').setAttribute('url_replace', 'https://www.bing.com');    
});